export interface SearchNoveltyRequest {
    /**
     * 任务ID
     */
    task_id: string;
    cc_num?: string;
}

export type SearchNoveltyResponse = void;

/**
 * 发起检索 API
 */
export interface FtoReportSearchApi {
    /**
     * 开始检索
     * @param data 请求参数
     * @returns 检索结果
     */
    startSearchNovelty(data: SearchNoveltyRequest): Promise<SearchNoveltyResponse>;
}

export const FtoReportSearchApi = Symbol.for('FtoReportSearchApi');
